import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    username: '',
    role: '',
    overTime:0,
    reminderTime:12,
    infor:{},
    resetToken:'',
    // site:''
  },
  mutations: {
    changeUsername(state, username) {
      state.username = username
    },
    changeRole(state, role) {
      state.role = role
    },
    changeOverTime(state, time) {
      state.overTime = time
    },
    changeReminderTime(state,time){
      state.reminderTime=time
    },
    changeInfo(state, info) {
      state.info = info
    },
    changeResetToken(state, token) {
      state.resetToken = token
    }
  },
  actions: {
  },
  modules: {
  }
})
